export { default } from './FundingInformationSection';
